import { motion } from "framer-motion";

export function TerminalGrid() {
  return (
    <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden bg-[#09090b]">

      {/* Dust Particles */}
      {[...Array(15)].map((_, i) => (
        <motion.div
          key={`dust-${i}`}
          initial={{ opacity: 0.1, y: "100%", x: Math.random() * 100 + "%" }}
          animate={{ y: "-20%", opacity: [0, 0.2, 0] }}
          transition={{ 
            duration: Math.random() * 15 + 15, 
            repeat: Infinity, 
            ease: "linear" 
          }}
          className="absolute w-[1.5px] h-[1.5px] bg-indigo-500/30 rounded-full"
        />
      ))}

      {/* Structural Grid */}
      <div 
        className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,#27272a_1px,transparent_1px),linear-gradient(to_bottom,#27272a_1px,transparent_1px)] bg-[size:6rem_6rem] opacity-20" 
      />

    </div>
  );
}